import Vue from 'vue';

if (!ACC.EventBus) {
	ACC.log.info("ACC.EventBus init");
	ACC.EventBus = new Vue();
}
export const EventBus = ACC.EventBus;



// WEBPACK FOOTER //
// ./src/global/event-bus.js